import { render, staticRenderFns } from "./LatestReleases.vue?vue&type=template&id=2379ec22&scoped=true&"
import script from "./LatestReleases.vue?vue&type=script&lang=js&"
export * from "./LatestReleases.vue?vue&type=script&lang=js&"
import style0 from "./LatestReleases.vue?vue&type=style&index=0&id=2379ec22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2379ec22",
  null
  
)

export default component.exports